import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import _ from 'lodash';
import Button from 'src/components/form/Button';
import { Link } from 'react-router-dom';

interface TileControlImplementationProps {
  controls: number;
  live: number;
}

export const TileControlImplementation: React.FC<TileControlImplementationProps> = ({ controls, live }) => {
  const percentage = Math.round((live / controls) * 100);
  const isEmpty = _.isNaN(percentage);

  return (
    <BaseCard>
      <span className="c-title">Control Implementation</span>
      <span className="description">
        Currently{' '}
        <b>
          {live}/{controls} controls are live
        </b>{' '}
        in your Risk Management Plan.
      </span>
      <div style={{ flex: 1 }} />
      {!isEmpty ? (
        <Poppins weight={600} color="gp1" px={26}>
          {percentage}%
        </Poppins>
      ) : (
        <Link to="/risk-management">
          <Button primary>+ Add Control</Button>
        </Link>
      )}
    </BaseCard>
  );
};
